// apps/web/src/lib/config.ts
const FALLBACK_SERVER_URL = 'http://localhost:3000';
const FALLBACK_SITE_URL = 'https://stardecide.com';

function getServerUrl(): string {
  const envUrl = process.env.NEXT_PUBLIC_SERVER_URL?.trim();
  if (envUrl) {
    return envUrl;
  }
  return FALLBACK_SERVER_URL;
}

export const SERVER_URL = getServerUrl();

export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL?.trim() || FALLBACK_SITE_URL;

function getStripePublishableKey(): string {
  const key = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY?.trim();
  if (!key) {
    return '';
  }
  return key;
}

export const STRIPE_PUBLISHABLE_KEY = getStripePublishableKey();
